import { gql } from "graphql-tag"

const DELETE_NEWS = gql`
  mutation deleteNews($id: ID!, $cascadeHomeVideo: Boolean) {
    deleteNews(id: $id, cascadeHomeVideo: $cascadeHomeVideo) {
      status
    }
  }
`

export default DELETE_NEWS
